import { useQuery, keepPreviousData } from '@tanstack/react-query'
import { queryKeys } from '@core/Data/ReactQuery/constants'
import { getRaceFieldSummaryDataFromApi } from './api'

export const useRaceFieldSummaryData = ({
  racecourseSeq,
  selectionDate,
  raceNumber,
}: {
  racecourseSeq?: number
  selectionDate?: string
  raceNumber?: number
}) =>
  useQuery({
    queryKey: [queryKeys.racePageFieldSummary(racecourseSeq, selectionDate, raceNumber)],
    queryFn: () => getRaceFieldSummaryDataFromApi(racecourseSeq, selectionDate, raceNumber),
    staleTime: Infinity,
    gcTime: 0,
    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData,
    enabled: !!racecourseSeq && !!selectionDate && !!raceNumber,
  })
